import { Routes, Route } from "react-router-dom";
import StudentinfoLayout from "./StudentinfoLayout";
import StudentDashboard from "../../Pages/StudentInfo/StudentDashboard";
import StudentInfoAddApplication from "../../Pages/StudentInfo/StudentInfoAddApplication";
import StudentInfoApplication from "../../Pages/StudentInfo/StudentInfoApplication";
import ErrorPage from "../../ErrorPage";



const StudentLayoutRoute = () => {
  return (
    <StudentinfoLayout>
      <Routes>
         <Route path="dashboard" element={<StudentDashboard/>} />
        <Route path="add" element={<StudentInfoAddApplication/>} />
        <Route path="view" element={<StudentInfoApplication/>} />
        <Route path="*" element={<ErrorPage />} />
        {/* Add more super admin pages here */}
      </Routes>
    </StudentinfoLayout>
  );
};

export default StudentLayoutRoute;
